import {ShouldSkipLazyLoadFn, ShouldSkipLazyLoadType} from 'app/interface';
import {addScrollDeeplinkItemAction} from 'app/modules/scrollDeeplink/actions';
import {getLoadingType} from 'app/utils/initialize/getLoadingType';
import {pageLinkHashHasId} from 'app/utils/initialize/pageLinkHashHasId';
import {SectionWithHeadlineConfig} from 'interfaces/common/components/general/sectionwithheadline/sectionWithHeadlineConfig';

export const shouldSkipLazyLoad: ShouldSkipLazyLoadFn<SectionWithHeadlineConfig> = ({config}) => {
    const sectionId = config?.cId;
    if (!sectionId) {
        return 'LOAD_LAZY';
    }

    addScrollDeeplinkItemAction({type: 'DEEPLINK', cId: config.cId, list: [sectionId]});

    const loadingTypes = new Set<ShouldSkipLazyLoadType>();
    const hasReferenceInLink = pageLinkHashHasId(sectionId);
    if (hasReferenceInLink) {
        loadingTypes.add('LOAD_EAGER');
    }

    const hash = window.location.hash.substring(1);
    if (hash && sectionId === hash) {
        loadingTypes.add('LOAD_EAGER_WITH_SCROLL_TO');
        addScrollDeeplinkItemAction({type: 'LAZY_SCROLL', component: 'SECTION_WITH_HEADLINE', cId: config.cId});
    }

    return getLoadingType(loadingTypes);
};
